module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "fm1"
    }
  })]), _c('a', {
    attrs: {
      "id": "fm1"
    }
  }, [_c('div', {
    staticClass: "fmhT"
  }, [_c('b', [_c('i', [_vm._v("How to Use This Book")])])]), _vm._v(" "), _c('div', {
    staticClass: "fmtx1"
  }, [_vm._v("Look no further: everything you need to write clear and efficient e-mails is between the covers of this book!")]), _vm._v(" "), _c('div', {
    staticClass: "leftAligned"
  }, [_c('img', {
    staticClass: "imgepub",
    attrs: {
      "alt": "003",
      "src": "bano_9781601638632_oeb_003_r1.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "fmtx1"
  }, [_c('b', [_vm._v("Models")]), _vm._v(" "), _c('i', [_vm._v("show you how it’s done.")])]), _vm._v(" "), _c('div', {
    staticClass: "leftAligned"
  }, [_c('img', {
    staticClass: "imgepub",
    attrs: {
      "alt": "004",
      "src": "bano_9781601638632_oeb_004_r1.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "fmtx1"
  }, [_c('b', [_vm._v("Maps")]), _vm._v(" "), _c('i', [_vm._v("provide flexible document outlines for every e-mail task.")])]), _vm._v(" "), _c('div', {
    staticClass: "leftAligned"
  }, [_c('img', {
    staticClass: "imgepub",
    attrs: {
      "alt": "005",
      "src": "bano_9781601638632_oeb_005_r1.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "fmtx1"
  }, [_c('b', [_vm._v("Tools")]), _vm._v(" "), _c('i', [_vm._v("explains the why and how of e-mail English.")])]), _vm._v(" "), _c('div', {
    staticClass: "leftAligned"
  }, [_c('img', {
    staticClass: "imgepub",
    attrs: {
      "alt": "006",
      "src": "bano_9781601638632_oeb_006_r1.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "fmtx1"
  }, [_c('b', [_vm._v("Netiquette")]), _vm._v(" "), _c('i', [_vm._v("describes e-mail trends.")])]), _vm._v(" "), _c('div', {
    staticClass: "leftAligned"
  }, [_c('img', {
    staticClass: "imgepub",
    attrs: {
      "alt": "007",
      "src": "bano_9781601638632_oeb_007_r1.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "fmtx1"
  }, [_c('b', [_vm._v("Options")]), _vm._v(" "), _c('i', [_vm._v("illustrates how to swap words and phrases.")])]), _vm._v(" "), _c('div', {
    staticClass: "leftAligned"
  }, [_c('img', {
    staticClass: "imgepub",
    attrs: {
      "alt": "008",
      "src": "bano_9781601638632_oeb_008_r1.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "fmtx1"
  }, [_c('b', [_vm._v("Inbox")]), _vm._v(" "), _c('i', [_vm._v("helps control the impression your e-mail makes.")])]), _vm._v(" "), _c('div', {
    staticClass: "leftAligned"
  }, [_c('img', {
    staticClass: "imgepub",
    attrs: {
      "alt": "009",
      "src": "bano_9781601638632_oeb_009_r1.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "fmtx1"
  }, [_c('b', [_vm._v("Edit")]), _vm._v(" "), _c('i', [_vm._v("shows you how to revise your e-mail.")])]), _vm._v(" "), _c('div', {
    staticClass: "leftAligned"
  }, [_c('img', {
    staticClass: "imgepub",
    attrs: {
      "alt": "010",
      "src": "bano_9781601638632_oeb_010_r1.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "fmtx1"
  }, [_c('b', [_vm._v("Advice")]), _vm._v(" "), _c('i', [_vm._v("supplies practical guidance on essential writing issues.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8f6625ee","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bano_9781601638632_oeb_fm1_r1.vue
// module id = 72
// module chunks = 0